import React from 'react';
import classNames from 'classnames';
import './skeleton.css';

function CardSkeleton({ className }: { className?: string }) {
  return (
    <div role="status" className={classNames('sk-root sk-card', className)}>
      <div className="sk-box sk-card-media" />
      <div className="sk-line" style={{ width: '60%', marginBottom: '10px' }} />
      <div className="sk-line" style={{ marginBottom: '8px' }} />
      <div className="sk-line" style={{ width: '84%', marginBottom: '8px' }} />
      <div className="sk-line" style={{ width: '46%' }} />
      <span className="sr-only">Loading...</span>
    </div>

  )
}

export default CardSkeleton